// extracted by mini-css-extract-plugin
module.exports = {"editor":"editor_editor__AZ5q8","title":"editor_title__3N7i_","subtitle":"editor_subtitle__LTnBk"};